import { DataScope, DataItem } from 'scrivito'

import { DATA_SCOPE_ERROR } from '@/Components/error/constants'

export const getDataItems = (dataScope?: DataScope) => {
  let error: unknown
  let dataItems: DataItem[] = []

  if (!dataScope) {
    error = DATA_SCOPE_ERROR
    return { dataItems, error }
  }
  try {
    dataItems = dataScope.take()
  } catch (e) {
    dataItems = []
    error = e
  }
  return { dataItems, error }
}
